"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawAccordion = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));
/** A stateless accordion component */


const RawAccordion = _ref => {
  let {
    type,
    label,
    sublabel,
    headerElement,
    children,
    name,
    classNames,
    id,
    onClick,
    expanded
  } = _ref;
  const {
    wrapper,
    header,
    content,
    expanded: expandedClassName,
    label: labelClassName,
    sublabel: sublabelClassName
  } = classNames || {};
  const headerID = "".concat(id, "-header");
  const contentID = "".concat(id, "-content");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.Accordion, wrapper)
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)(_indexModule.default.header, header, {
      [_indexModule.default.headerSmall]: type === 'small'
    }),
    type: "button",
    "aria-expanded": expanded,
    "aria-controls": contentID,
    id: headerID,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.labelWrapper
  }, (label || headerElement) && /*#__PURE__*/_react.default.createElement("div", {
    className: labelClassName
  }, label || headerElement), sublabel && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(_indexModule.default.sublabel, sublabelClassName)
  }, sublabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.headerIcon, {
      [_indexModule.default.expanded]: expanded
    })
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    size: type === 'small' ? 'small' : 'medium',
    type: "chevron-down",
    "aria-label": "".concat(expanded ? 'Collapse' : 'Show', " ").concat(name || id)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      [_indexModule.default.expanded]: expanded,
      [_indexModule.default.collapsed]: !expanded,
      [expandedClassName || '']: expanded
    }),
    "aria-labelledby": headerID,
    "aria-hidden": !expanded,
    id: contentID,
    role: "region"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.contentWrapper, content, {
      [_indexModule.default.contentWrapperSmall]: type === 'small'
    })
  }, children)));
};

exports.RawAccordion = RawAccordion;
RawAccordion.propTypes = {
  expanded: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func
};